import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Layout from "./../../wrapper";
import { MannualInComp } from "../../Components/MannualInvoice/index";
import { logInUserInfo } from "../../Actions/Users";
import withRoutes from "../../HOC/HocRoutes";

const MannualInvoice = (props) => {
  const dispatch = useDispatch();

  const logInUser = useSelector((state) => state.logInUsers);
  const ServerSetting = useSelector((state) => state.ServerSetting);

  useEffect(() => {
    if (logInUser) return;

    fetch(
      "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
      {
        headers: { Accept: "application/json; odata=verbose" },
      }
    )
      .then((response) => {
        if (!response.ok) {
          props.navigate("/login");
          throw response;
        }
        return response.json();
      })
      .then((res) => {
        if (res.status === "success") {
          const userInfo = res.data;

          props.setActiveLanguage(
            userInfo?.attributes?.lang || "en"
          );

          dispatch(logInUserInfo(userInfo));
        } else if (res?.statusCode === "440") {
          window.location.replace("/login");
        } else if (res?.statusCode) {
          let err = res?.message?.split(":");
          if (err?.[1]) {
            err[1] = err[1].replace(")", "");
            toast.error(props.translate(err[1]));
          }
          props.navigate("/login");
        }
      })
      .catch(() => {
        toast.error("somethingWentWrong");
      });
  }, [logInUser, dispatch, props]);

  if (!logInUser) {
    return null;
  }

  return (
    <Layout {...props} noSidebar>
      <MannualInComp {...props} />
    </Layout>
  );
};

export default withRoutes(MannualInvoice);
